import * as yup from 'yup'
import { getProductSchema } from '@/modules/Contract/components/New/schema'

/**
 * Schema riêng cho luồng tạo dịch vụ ADDON.
 *
 * KHÔNG dùng chung `contractsNewSchema` vì addon là service con của một service
 * đã tồn tại — nó không mang thông tin cấp hợp đồng (contract_role /
 * contract_direction / contract dates / customer_id). Trước đây form addon
 * mượn `contractsNewSchema` nên luôn fail validate ở 2 field
 * contract_role/contract_direction (không hề có UI để nhập) → submit im lặng,
 * không bắn request. Schema này chỉ validate đúng thứ addon thực sự gửi lên:
 *   handleSubmit chỉ dùng values.order.products[0] + employee_sale_tracking_ids.
 *
 * Validate per-product tái dùng getProductSchema (route theo product_group_name
 * của service cha / template_name của product) để giữ nguyên ràng buộc nghiệp vụ
 * về giá / config option như luồng hợp đồng.
 */
const createAddonSchema = yup.object().shape({
    // BE khai binding:"required" cho slice này (service.types.go) → mảng rỗng cũng
    // bị BE trả 400. Chặn ngay ở FE để hiển thị lỗi rõ ràng thay vì để rơi xuống BE.
    employee_sale_tracking_ids: yup
        .array()
        .of(yup.number())
        .min(1, 'employee-sale-tracking-required')
        .required('employee-sale-tracking-required'),
    order: yup.object().shape({
        products: yup
            .array()
            .of(yup.lazy((product) => getProductSchema(product)))
            .min(1),
    }),
})

export default createAddonSchema
